
  import {Component, Vue} from "vue-property-decorator";
  import AppPageHeader from "@/components/AppPageHeader.vue";
  import UserIntro from "@/modules/Home/components/UserIntro.vue";
  import FavoriteCarsPopup from "@/modules/Home/components/popups/FavoriteCarsPopup.vue";
  import GetAccessPopup from "@/modules/Home/components/popups/GetAccessPopup.vue";
  import InstallAppInstructionPopup from "@/modules/Home/components/popups/InstallAppInstructionPopup.vue";
  import ProfileBlock from "@/modules/Home/components/other/ProfileBlock.vue";

  @Component({
    components: {
      ProfileBlock,
      InstallAppInstructionPopup,
      AppPageHeader,
      UserIntro,
      FavoriteCarsPopup,
      GetAccessPopup,
    },
  })
  export default class PageHome extends Vue {
    isLoading: boolean = true;

    get dialogs() { return this.$store.state.dialog.home; }

    async created() {
      await this.$store.dispatch('auth/init');
      await this.$store.dispatch('book/initBooksForPage', this.$route.name);
      await this.$store.dispatch('initialized');
      this.isLoading = false;
    }

  }
